export default {
	pageSize: 50,
	searchableActions: ["clear", "select-option"],
};
